import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	min-height: var(--main-height);
	flex-direction: column;

	.top-wrapper {
		text-align: center;

		margin-top: 30px;

		h1 {
			font-size: 35px;
		}
		p {
			margin-top: 20px;
		}
	}

	.articles-wrapper {
		display: flex;
		flex-direction: column;
		margin-top: 30px;
		gap: 40px;
		max-width: 50%;

		h2 {
			font-size: 24px;
			margin-bottom: 15px;
		}
		p,
		li {
			font-size: 16px;
		}
		ul {
			margin-top: 10px;
			margin-bottom: 40px;
		}

		.topic-list {
			li {
				list-style: disc;
			}
		}
		.numeric-list {
			li {
				list-style: decimal;
			}
		}
		.article-image {
			display: flex;
			justify-content: center;
			img {
				max-width: 500px;
				border-radius: 10px;
			}
		}
		.article-video {
			display: flex;
			justify-content: center;
			iframe {
				width: 500px;
				height: 280px;
				border-radius: 10px;
			}
		}
	}
`;

export const Wrapper = styled.div`
	width: 1100px;
	margin: 0 auto;
`;
